import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import { CircularProgress } from '@mui/material';

import Copyright from '../../components/common/Copyright';
import { sendPasswordReset } from '../../data/firebase';

const ForgotPassword = () => {
  const [error, setError] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [isSending, setIsSending] = useState<boolean>(false);

  const [formError, setFormError] = useState<string>();

  const doResetPassword = async (email: string) => {
    try {
      setIsSending(true);
      await sendPasswordReset(email);
      setMessage(
        'Reset password email has been sent! Please check your inbox/spam.'
      );
      setError('');
      setIsSending(false);
    } catch (error: any) {
      const errorMessage = error.message;
      setMessage('');
      setError(errorMessage);
      setIsSending(false);
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setFormError('');
    const data = new FormData(event.currentTarget);
    const email = data.get('email');

    if (typeof email === 'string') {
      doResetPassword(email);
    } else {
      setFormError(
        'There was an issue with the form submission. Please contact system admin.'
      );
    }
  };

  const errorDisplay = formError || error;

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          marginBottom: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Reset Password
        </Typography>
        {errorDisplay && (
          <Alert sx={{ mt: 1 }} severity="error">
            {errorDisplay}
          </Alert>
        )}
        {message && (
          <Alert sx={{ mt: 1 }} severity="success">
            {message}
          </Alert>
        )}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            disabled={isSending}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={isSending}
          >
            {isSending ? (
              <CircularProgress color="inherit" />
            ) : (
              'Reset Password'
            )}
          </Button>
          <Grid container>
            <Grid item xs>
              <Link component={RouterLink} to={'/login'} variant="body2">
                Back to Login
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Copyright />
    </Container>
  );
};

export default ForgotPassword;
